"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANNER_DATA = void 0;
var CheckCircle_1 = __importDefault(require("@material-ui/icons/CheckCircle"));
var Error_1 = __importDefault(require("@material-ui/icons/Error"));
var Info_1 = __importDefault(require("@material-ui/icons/Info"));
var warning_component_1 = require("../assets/icons/warning_component");
exports.BANNER_DATA = Object.freeze({
    warning: {
        color: 'warn',
        icon: warning_component_1.WarningIcon,
    },
    error: {
        color: 'danger',
        icon: Error_1.default,
    },
    success: {
        color: 'safe',
        icon: CheckCircle_1.default,
    },
    info: {
        color: 'primary',
        icon: Info_1.default,
    },
    default: {
        color: 'primary',
        icon: null,
    },
});
